module.exports = __webpack_public_path__ + "fonts/Golos-Text_Black.1b1686a.woff";